import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { PropertyDto, UserDto } from '@workspace/data-types';
import { AvatarAuraComponent, LuxonDatePipe } from '@workspace/ng-aura';

@Component({
  selector: 'etxe-property-associated-users',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    RouterLink,
    AvatarAuraComponent,
    LuxonDatePipe,
  ],
  templateUrl: './property-associated-users.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyAssociatedUsersComponent {
  property = input.required<PropertyDto>();

  asUser(user: unknown): UserDto | null {
    return user && typeof user === 'object' && ('_id' in user || 'identity' in user)
      ? (user as UserDto)
      : null;
  }
}
